<template>
  <div class="modal-overlay">
    <div class="modal-card">
      <!-- HEADER -->
      <div class="modal-header">
        <h3 class="font-weight-bold">
          {{ $t("otp.header") }}
        </h3>
        <span
          class="close-btn"
          @click="$emit('close')"
        >✕</span>
      </div>

      <!-- BODY -->
      <div class="modal-body">
        <img
          src="@/assets/image/checklist-otp.png"
          class="otp-illustration"
        >

        <p class="otp-desc">
          {{ $t("otp.desc1") }}
          {{ $t("otp.desc2") }}
        </p>

        <p class="otp-email">
          {{ userEmail }}
        </p>

        <p class="otp-desc">
          {{ $t("otp.desc3") }}
        </p>

        <form @submit.prevent="verifyOtp">
          <div class="d-flex justify-content-between otp-wrapper">
            <input
              v-for="(digit, index) in otp"
              :key="index"
              ref="otpInput"
              v-model="otp[index]"
              type="text"
              maxlength="1"
              class="otp-input"
              @input="onOtpInput(index)"
              @keydown.backspace="onOtpBackspace(index)"
            >
          </div>

          <button
            type="submit"
            class="verify-btn"
            :disabled="loading"
          >
            {{ loading ? 'Verifying...' : $t("otp.button.verify") }}
          </button>
        </form>

        <div class="info">
          <span>
            {{ $t("otp.info") }}
          </span>
        </div>
        <div class="resend">
          <span>
            {{ $t("otp.resend-question") }}
          </span>
          <a
            class="resend-link"
            href="#"
            @click.prevent="resendOtp"
          >
            {{ $t("otp.resend-link") }}
          </a>
        </div>
      </div>
    </div>
    <ModalUnsuccessful
      v-show="modal.unsuccessful"
      :text-modal="modal.textModal"
      @closeModal="closeModal"
    />
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'
import Api from '@/utils/Api'
import { isToday } from 'date-fns'
import ModalUnsuccessful from '@/components/modal/ModalUnsuccessful'

export default {
  components: {
    ModalUnsuccessful
  },
  data () {
    return {
      otp: ['', '', '', '', ''],
      loading: false,
      userEmail: '',
      modal: {
        unsuccessful: false,
        textModal: ''
      }
    }
  },

  mounted () {
    this.userEmail = localStorage.getItem('mfaUserEmail')
  },

  methods: {
    onOtpInput (index) {
      if (this.otp[index] && index < 4) {
        this.$refs.otpInput[index + 1].focus()
      }
    },

    onOtpBackspace (index) {
      if (!this.otp[index] && index > 0) {
        this.$refs.otpInput[index - 1].focus()
      }
    },

    async verifyOtp () {
      this.$v.$touch()
      if (this.$v.$invalid) return

      this.loading = true
      const otpCode = this.otp.join('')
      const userId = localStorage.getItem('mfaUserId')

      try {
        const res = await Api.auth.verifyOtpMfa({ userId, otpCode })
        if (res.data.status === 200 || res.data.status === 2001) {
          localStorage.removeItem('mfaUserId')
          localStorage.removeItem('mfaUserEmail')
          localStorage.token = res.data.data.token
          localStorage.refreshToken = res.data.data.refreshToken
          localStorage.login = true

          const { data: profile } = await Api.users.me()
          localStorage.profile = JSON.stringify(profile)
          await this.setDefaultRoute()
          this.nextPage(profile)

          this.$emit('success')
        } else if (res.data.status === 40113) {
          if (this.$i18n.locale === 'en') {
            this.modal.textModal = 'Max Attempt Insert OTP MFA Reached'
          } else if (this.$i18n.locale === 'id') {
            this.modal.textModal = 'Percobaan untuk insert OTP MFA melebihi batas maksimal'
          }
          this.showModal()
        } else {
          if (this.$i18n.locale === 'en') {
            this.modal.textModal = 'OTP MFA not valid'
          } else if (this.$i18n.locale === 'id') {
            this.modal.textModal = 'OTP MFA tidak valid'
          }
          this.showModal()
        }
      } catch (e) {
        if (this.$i18n.locale === 'en') {
          this.modal.textModal = 'Failed verify OTP MFA'
        } else if (this.$i18n.locale === 'id') {
          this.modal.textModal = 'Gagal memverifikasi OTP MFA'
        }
        this.showModal()
      } finally {
        this.loading = false
      }
    },

    async resendOtp () {
      const userId = localStorage.getItem('mfaUserId')
      await Api.auth.resendOtpMfa({ userId })
    },

    showModal () {
      this.modal.unsuccessful = true
    },

    closeModal () {
      this.modal.unsuccessful = false
    },

    setDefaultRoute () {
      const profile = JSON.parse(localStorage.getItem('profile'))
      const routing = profile.role.permissions
      routing.sort((a, b) => a.level - b.level)
      localStorage.setItem('defaultRoute', JSON.stringify(routing[0]))
    },

    nextPage ({ lastSubmissionDate }) {
      const defaultRouting = JSON.parse(localStorage.getItem('defaultRoute'))
      if ((defaultRouting.category === 'my_dhm' || defaultRouting.category === 'all_dhm') &&
          defaultRouting.permissions.includes('add')) {
        if (lastSubmissionDate && isToday(new Date(lastSubmissionDate))) {
          this.$router.push({ name: defaultRouting.category })
        } else {
          this.$router.push({ name: 'success-login' })
        }
      } else {
        this.$router.replace({ name: defaultRouting.category })
      }
    }
  },

  validations: {
    otp: {
      required,
      minLength: minLength(5)
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-card {
  background: white;
  width: 420px;
  max-width: 90vw;
  border-radius: 16px;
  padding: 32px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  font-weight: bold;
}

.otp-illustration {
  width: 160px;
  margin: 0 auto 16px;
  display: block;
}

.otp-desc {
  text-align: center;
  font-size: 14px;
  margin-bottom: 6px;
}

.otp-email {
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 6px;
}

.info {
  font-size: 13px;
  text-align: center;
}

.resend {
  font-size: 13px;
  text-align: center;
  color: #D3D3D3;
}

.resend-link {
  font-size: 13px;
  text-align: center;
  color: #18a2b8;
}

.otp-wrapper {
  margin: 16px 0;
}

.otp-input {
  width: 48px;
  height: 52px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  border-radius: 8px;
  border: 1px solid #D3D3D3;
}

.otp-input:focus {
  outline: none;
  border-color: #18a2b8;
}

.verify-btn {
  width: 100%;
  background: #18a2b8;
  border: none;
  color: #fff;
  padding: 10px;
  border-radius: 10px;
  margin-bottom: 12px;
  font-size: 14px;
}

.close-btn {
  cursor: pointer;
  font-size: 16px;
}

/* MOBILE */

@media (max-height: 700px) {
  .modal-card {
    max-height: 90vh;
    overflow-y: auto;
  }
}
</style>
